export default {
  List: {
    Title: "Chức danh",
    JobTitleCode: "Mã chức danh",
    JobTitleName: "Tên chức danh",
    SortOrder: "Thứ tự",
    Description: "Ghi chú",
  },
  Detail: {
    Add: "Thêm chức danh",
    Edit: "Sửa chức danh",
    JobTitleName: "Tên",
    SortOrder: "Thứ tự",
  },
};
